import { Grid } from '@material-ui/core';
import QCXMainLayout from '../../../../components/main-layout/QCXMainLayout';
import GestaoAVistaEtapaCard from '../../import/gestao-a-vista/components/GestaoAVistaEtapaCard';
import GestaoAVistaEtapasSemaforo from '../../import/gestao-a-vista/components/GestaoAVistaEtapasSemaforo';
import GestaoAVistaFollowUpList from '../../import/gestao-a-vista/components/GestaoAVistaFollowUpList';
import useGestaoAVista from '../../import/gestao-a-vista/hooks/gestaoAVista.hook';

export default function GestaoAVistaExportacaoDashboardPage({ authInfo = {} }) {
  const {
    selectedEstagio,
    setSelectedEstagio,
    selectedEtapa,
    setSelectedEtapa,
    isLoadingProcessosCapa,
    isLoadingEtapasCapa,
    isLoadingProcessos,
    processosCapaConfig,
    etapasCapa,
    processos,
    processosCount,
    listConfig,
    onListConfigChange,
  } = useGestaoAVista('EXPORTACAO');

  return (
    <QCXMainLayout pageTitle="Gestão à vista" breadcrumbs={[]} isLoading={false} authInfo={authInfo} forceDefaultTheme>
      <Grid container spacing={2} xs={12} style={{ marginBottom: 64 }}>
        {processosCapaConfig.map((gestaoEtapa) => (
          <Grid item xs={12} md={6} lg={6}>
            <GestaoAVistaEtapaCard
              name={gestaoEtapa.name}
              total={gestaoEtapa.total}
              totalAereo={gestaoEtapa.aereo}
              totalMaritimo={gestaoEtapa.maritimo}
              totalRodoviario={gestaoEtapa.rodoviario}
              backgroundColor={gestaoEtapa.backgroundColor}
              light={gestaoEtapa.light}
              loading={isLoadingProcessosCapa}
              selected={selectedEstagio === gestaoEtapa.estagio}
              onSelectedChange={() => setSelectedEstagio(gestaoEtapa.estagio)}
              noneSelected={selectedEstagio === undefined}
            />
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={2} xs={12} style={{ marginTop: 32 }}>
        <Grid item xs={12}>
          <GestaoAVistaEtapasSemaforo
            loading={isLoadingEtapasCapa}
            etapasNoPrazo={etapasCapa.etapasNoPrazo}
            etapasARealizar={etapasCapa.etapasARealizar}
            etapasVencendo={etapasCapa.etapasVencendo}
            etapasVencidas={etapasCapa.etapasVencidas}
            selected={selectedEtapa}
            onSelectedChange={setSelectedEtapa}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} xs={12} style={{ marginTop: 32 }}>
        {selectedEstagio || selectedEtapa ? (
          <GestaoAVistaFollowUpList
            pageSize={listConfig?.pageSize ?? 0}
            onConfigChangeCallback={onListConfigChange}
            processosCount={processosCount}
            processos={processos}
            loading={isLoadingProcessos}
          />
        ) : null}
      </Grid>
    </QCXMainLayout>
  );
}
